import { motion } from "framer-motion";
import { useLang } from "../../lib/i18n";

export const Method = () => {
  const { t } = useLang();
  return (
  <section data-testid="method-section" className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
    <div className="grid gap-12 lg:grid-cols-12">
      <motion.div className="lg:col-span-5" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9 }}>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6D9BC]">{t.methodEyebrow}</p>
        <h2 className="mt-6 font-display text-4xl leading-[1.05] text-[#F4EFE6] md:text-5xl">
          {t.methodTitle[0]}<em className="text-[#E6D9BC]">{t.methodTitle[1]}</em>{t.methodTitle[2]}
        </h2>
      </motion.div>
      <div className="grid gap-px overflow-hidden rounded-3xl border border-[#E6D9BC]/15 bg-[#E6D9BC]/15 sm:grid-cols-3 lg:col-span-7">
        {t.steps.map(([title, d], i) => {
          const n = `0${i + 1}`;
          return (
          <motion.div
            key={n}
            data-testid={`method-step-${n}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.12 }}
            className="group bg-[#1E2A32] p-8 transition-colors duration-500 hover:bg-[#25343E]"
          >
            <p className="font-mono text-sm text-[#E6D9BC]">{n}</p>
            <h3 className="mt-16 font-display text-2xl text-[#F4EFE6]">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#BAC6CE]">{d}</p>
          </motion.div>
          );
        })}
      </div>
    </div>
  </section>
  );
};
